import { Dispatch} from "react";
import { Battery } from "../types";
import { actions } from "../state";
import {IADPActions, IADPHeaderActions } from "../state/Actions";
import { useDedupEffect } from "../util/useDedupEffect";
const logPrefix = "[ADPClient][BatteryServiceHook]"
export function useBatteryService(dispatch: Dispatch<IADPHeaderActions>,dispatchToApp: Dispatch<IADPActions>) {
  async function getBatteryLevel() {
    // @ts-ignore
    const batteryLevel:Battery = await navigator.getBattery();
    dispatch(actions.createSetBatteryAction(batteryLevel));
    dispatchToApp(actions.createSetBatteryAction(batteryLevel));
    // @ts-ignore
    navigator.getBattery().then((battery) => {
      battery.onchargingchange = () => {
          console.log(logPrefix,`battery is charging: ${battery.charging}]`);
         dispatch(actions.createSetBatteryAction(battery));
         //dispatchToApp(actions.createSetBatteryAction(battery));
       };
      battery.onlevelchange = () => {
          console.log(logPrefix,`battery level: ${battery.level * 100}]`);
         // DeviceMetricsService.patch(battery.level?.toString());
         dispatch(actions.createSetBatteryAction(battery));
         dispatchToApp(actions.createSetBatteryAction(battery));
      };
  });
}
useDedupEffect(() => {
    getBatteryLevel();
  }, []);
}


